import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

/**
 * Guards /rx-mgmt/9c4f2e routes.
 * Requires a valid access token AND SUPER_ADMIN role specifically.
 * Redirects anyone else to /auth/login — never reveals the portal URL.
 */
export const superAdminGuard: CanActivateFn = () => {
  const auth   = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn() || auth.getRole() !== 'SUPER_ADMIN') {
    // Super admins with a cleared token go back to their portal; everyone else to login
    const isSuperAdmin = auth.getRole() === 'SUPER_ADMIN';
    router.navigate([isSuperAdmin ? '/rx-portal/b7f3e2a9' : '/auth/login']);
    return false;
  }

  return true;
};
